import { mapGetters, mapMutations, mapState } from 'vuex';
import SearchFilters from '~/components/Search/SearchFilters';

const mixin = type => {
  return {
    components: {
      SearchFilters,
    },
    computed: {
      ...mapGetters('auth', ['hasCatalogSubset']),
      ...mapState({
        sort: state => state.productsFilters[type].sort,
        pagination: state => state.productsFilters[type].pagination,
      }),
    },
    methods: {
      ...mapMutations({
        setCategories: 'productsFilters/setCategories',
        setActiveFilter: 'productsFilters/setActiveFilter',
        setActiveFilters: 'productsFilters/setActiveFilters',
        setSort: 'productsFilters/setSort',
        setPagination: 'productsFilters/setPagination',
        setQuery: 'productsFilters/setQuery',
        setDevice: 'productsFilters/setDevice',
        setOemCode: 'productsFilters/setOemCode',
        setInkAndTonersOnly: 'productsFilters/setInkAndTonersOnly',
        setDeviceModel: 'productsFilters/setDeviceModel',
        setDeviceBrand: 'productsFilters/setDeviceBrand',
      }),
      getFiltersFromUrl(data, convertTypes = false, urlString = null) {
        this.resetFilters();

        let url = urlString || window.location.href;
        url = decodeURI(url);

        url = url.split('?');

        // Return data if url length is not more then 1
        if (url.length < 2) {
          return data;
        }

        url = url[1];

        // Get params from url

        const params = url.split('&');

        // Loop through each parameter
        params.forEach(param => {
          const paramBits = param.split('=');
          let paramKey = paramBits[0];
          let paramValue = [];
          let shouldBeArray = false;

          // The string has no '=', making it invalid
          if (paramBits.length === 1) {
            return;
          }

          // Check if key contains bracket, which means that the value should be an array
          // If the key contains braket, we remove the brackets from the name
          // eslint-disable-next-line
          if (paramKey.indexOf('[]') !== -1) {
            paramKey = paramKey.substring(0, paramKey.length - 2);
            shouldBeArray = true;
          }

          if (shouldBeArray) {
            // Each value in the array should be separated by comma
            const arrayValues = paramBits[1].split(',');

            arrayValues.forEach(value => {
              if (convertTypes) {
                value = this.convertStringValueToCorrectType(value);
              }

              paramValue.push(decodeURIComponent(value.toString()));
            });
          } else if (convertTypes) {
            paramValue = this.convertStringValueToCorrectType(paramBits[1]);
          } else {
            paramValue = decodeURI(paramBits[1]);
          }

          if (paramKey === 'categories') {
            this.setCategories({ type, value: paramValue });
          } else if (paramKey === 'orderBy') {
            this.setSort({ type, value: paramValue });
          } else if (paramKey === 'limit') {
            this.setPagination({
              type,
              value: { ...this.pagination, limit: paramValue },
            });
          } else if (paramKey === 'query') {
            this.setQuery({ type, value: paramValue });
          } else if (paramKey === 'inkAndTonersOnly') {
            this.setInkAndTonersOnly({ type, value: paramValue });
          } else if (paramKey === 'oemCode') {
            this.setOemCode({ type, value: paramValue });
          } else if (paramKey === 'device') {
            this.setDevice({ type, value: paramValue });
          } else if (paramKey === 'deviceBrand') {
            this.setDeviceBrand({ type, value: paramValue });
          } else if (paramKey === 'deviceModel') {
            this.setDeviceModel({ type, value: paramValue });
          } else if (paramKey === 'oemCode') {
            this.setOemCode({ type, value: paramValue });
          } else if (paramKey === 'priceNet' || paramKey === 'priceGross') {
            const rangeValue = paramValue.split('-');
            this.setActiveFilter({
              type,
              name: paramKey,
              value: { from: rangeValue[0], to: rangeValue[1] },
            });
          } else {
            this.setActiveFilter({ type, name: paramKey, value: paramValue });
          }
        });

        return data;
      },

      convertStringValueToCorrectType(value) {
        let returnValue = null;

        /**
         * Some values contains hyphens (a date or a range)
         * If a string contains 2 hyphens, it will be treated like a date (2017-08-01). If the string contains
         * only 1 hyphen, it will be treated like a range (50-250). This means that a regular string might not
         * returned the way you expect.
         */

        let values = [];

        if (isNaN(value)) {
          values = value.split('-');
        } else {
          values[0] = value;
        }

        if (values.length === 3) {
          // This is a date (2017-3-25) as we have 2 dashes which gives 3 values
          // eslint-disable-next-line no-undef
          returnValue = decodeURI(paramValue);
        } else if (values.length === 2) {
          // If length of values is greater than 1 we assume it's a range with integer values
          returnValue = {};
          returnValue.from = parseFloat(values[0]);
          returnValue.to = parseFloat(values[1]);
        } else if (values.length === 1) {
          if (isNaN(values[0])) {
            // If the value is NaN (Not a Number), it must be a string
            const stringValue = decodeURI(values[0]);

            // Convert to boolean if string is 'true' or 'false'
            if (stringValue === 'true' || stringValue === 'false') {
              returnValue = JSON.parse(stringValue);
            } else {
              returnValue = stringValue;
            }
          } else {
            // It is a number
            returnValue = parseFloat(values[0]);
          }
        } else {
          // More then 3 hyphens, this must be a regular string
          returnValue = value;
        }

        return returnValue;
      },

      /**
       * Adds parameters to url
       */
      updateUrlParams(path, data) {
        this.$router.push(`${path}?${this.calculateUrlParams(data)}`);
      },

      calculateUrlParams(data) {
        let urlParams = '';

        for (const key in data) {
          let value = data[key];

          if (
            (value !== null && value !== '' && !Array.isArray(value) && value !== 'default') ||
            (Array.isArray(value) && value.length > 0)
          ) {
            if (urlParams.length > 1) {
              urlParams += '&';
            }
            if (Array.isArray(value)) {
              urlParams += key + '[]=';

              value.forEach(objectOrElement => {
                if (typeof objectOrElement === 'object') {
                  for (const property in objectOrElement) {
                    const propertyValue = objectOrElement[property];
                    urlParams += propertyValue;

                    if (property === 'min') {
                      urlParams += '-';
                    }
                  }
                } else {
                  urlParams += objectOrElement;
                }

                urlParams += ',';
              });

              urlParams = urlParams.substring(0, urlParams.length - 1);
            } else if (typeof value === 'object') {
              urlParams += key + '=';

              if (value.from) {
                urlParams += value.from + '-';
              } else {
                urlParams += '0-';
              }

              if (value.to) {
                urlParams += value.to;
              }
            } else {
              urlParams += key + '=';

              if (typeof value === 'string') {
                value = encodeURI(value);
              }

              urlParams += value;
            }
          }
        }

        // Prevent scroll to top if urlParams is empty
        if (urlParams.length === 0) {
          urlParams = '';
        }

        return urlParams;
      },
      resetFilters() {
        this.setCategories({
          type,
          value: [],
        });
        this.setActiveFilters({
          type,
          value: {},
        });
        this.setQuery({
          type,
          value: '',
        });
        this.setDevice({
          type,
          value: '',
        });
        this.setOemCode({
          type,
          value: '',
        });
        this.setDeviceModel({
          type,
          value: '',
        });
        this.setDeviceBrand({
          type,
          value: '',
        });
        this.setOemCode({
          type,
          value: '',
        });
        this.setInkAndTonersOnly({
          type,
          value: '',
        });
        const offset = this.$route.query.limit ? this.$route.query.limit : this.pagination.limit;
        this.setPagination({
          type,
          value: {
            limit: this.$route.query.limit ? this.$route.query.limit : 36,
            offset: this.$route.params.number
              ? (parseInt(this.$route.params.number) - 1) * parseInt(offset)
              : 0,
            countTotal: 0,
          },
        });
        this.setSort({
          type,
          value: '',
        });
      },
    },
  };
};

export default mixin;
